import React from 'react';

import {Avatar} from '@gravity-ui/uikit';

import {OrganizationIcon} from '../../../OrganizationIcon';
import {block} from '../../../cn';
import {DefaultDropdownAvatarProps} from '../UserDropdownAvatar';
import {getEmptyUserAvatar, getUserAvatar} from '../helpers';

const b = block('user-dropdown-avatar');

export const DefaultAvatar = (props: DefaultDropdownAvatarProps) => {
    const {
        size = 'm',
        user,
        url,
        title,
        internal,
        currentOrgId,
        organizationIcon,
        organizationIconSize,
    } = props;

    let imgUrl;
    if (user) {
        imgUrl = getUserAvatar(user, size, internal);
    } else if (url) {
        imgUrl = url;
    }

    return (
        <React.Fragment>
            {imgUrl ? (
                <Avatar
                    className={b('avatar', {organization: Boolean(currentOrgId)})}
                    size={size}
                    title={title}
                    imgUrl={imgUrl}
                    fallbackImgUrl={getEmptyUserAvatar(size)}
                />
            ) : null}
            {currentOrgId && (
                <OrganizationIcon
                    className={b('icon')}
                    orgId={currentOrgId}
                    icon={organizationIcon}
                    iconSize={organizationIconSize}
                />
            )}
        </React.Fragment>
    );
};
